import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// components
import ShowMoreBtn from "./showMoreBtn";
import CheckboxItems from "./checkboxItems";
// store
import { setFilter, removeFilter,setLoading } from "../../configureStore";
// services and helpers

import emptyFilters from "../../helper/emptyFilters";
const FieldSetCheckboxes = (props) => {
	const [showMore, setShowMore] = useState(false);
	const [showmoreIndex, setShowMoreIndex] = useState(null);
	const [allChecked, setAllChecked] = useState(false);
	const searchData = useSelector((state) => state.searchData);
	const global = useSelector((state) => state.global);
	const dispatch = useDispatch();
	useEffect(() => {
		if (
			Object.keys(searchData.filters[props.type]).length ===
			props.options.length
			) {
			setAllChecked(true);
		} else {
			setAllChecked(false);
		}
	}, [allChecked, props.options.length, searchData, props.type]);
	useEffect(() => {
		if (window.innerWidth > 768) {
			setShowMoreIndex(global.showMore.desktop);
		} else {
			setShowMoreIndex(global.showMore.mobile);
		}
	}, [showmoreIndex]);

	const showMoreStatus = (status) => {
		setShowMore(status);
	};
	const toggleAll = async (e) => {
		const target = e.currentTarget;
		const type = props.type;
		if (target.checked === true) {
			setAllChecked(true);
			// Get activities from selected activity group
			props.options.forEach(async(option) => {
				let name = null;
				if (type === "activityGroup") {
					name = option.activityGroupName;
				} else if (type === "amenity") {
					name = option.name;
				} else if (type === "discountCategory") {
					name = option.name;
				}
				await dispatch(
					setFilter({
						name: name,
						id: option[type + "Id"],
						type,
					}),
				);
			});
		} else {
			setAllChecked(false);
			props.options.forEach(async(option) => {
				await dispatch(removeFilter({ id: option[type + "Id"], type }));
			});
		}
		// fetch results
		dispatch(setLoading(true));
	};
	return (
		<div className="form__block">
			<fieldset className="form__fieldset">
				<legend className="form__legend">{props.label}</legend>
				<div className="form__grid">
					<div
						className={`form__grid-item `}
						id={"all"}
						key="all">
						<div className="form__group ">
							<div className="form__check">
								<input
									type="checkbox"
									name={`${props.type}-all`}
									id={`${props.type}-all`}
									checked={allChecked}
									className="form__check-input"
									onChange={(e) => {
										toggleAll(e);
									}}
								/>
								<label
									className="form__check-label"
									htmlFor={`${props.type}-all`}>
									{global.localization.filtersAll}
								</label>
							</div>
						</div>
					</div>
					<CheckboxItems
						options={props.options}
						showMore={showMore}
						showmoreIndex={showmoreIndex}
						type={props.type}
					/>
				</div>
			</fieldset>
			{props.options.length > showmoreIndex ? (
				<ShowMoreBtn
					callback={showMoreStatus}
					showless={props.showless}
					showmore={props.showmore}
				/>
			) : null}
		</div>
	);
};
export default FieldSetCheckboxes;
